import { z } from "zod";
import {
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  COMMUNITY_ID,
  CONTACT_NAME,
  EMAIL_ID,
  FEIN,
  IS_ACTIVE,
  NAME,
  PHONE_NO,
  STATE,
  WEBSITE,
  ZIPCODE,
} from "./consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [FEIN]: z.string().min(1, "This field is required").min(10, "Invalid FEIN"),
  [CONTACT_NAME]: z.string().optional(),
  [WEBSITE]: z.string().optional(),
  [PHONE_NO]: z.string().min(10, "This field is required"),
  [EMAIL_ID]: z
    .string()
    .min(1, "This field is required")
    .email("Invalid Email"),
  [IS_ACTIVE]: z.boolean().optional(),
  [ADDRESS_1]: z.string().optional(),
  [ADDRESS_2]: z.string().optional(),
  [STATE]: z.string().optional(),
  [CITY]: z.string().optional(),
  [ZIPCODE]: z
    .string()
    .optional()
    .refine((value) => !value || /^[0-9]{5}-[0-9]{4}$/.test(value), {
      message: "Enter ZIP code in XXXXX-XXXX format.",
    }),
  [COMMUNITY_ID]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
